import React, { useEffect, useState } from "react";
import general from "../../../general";
import { Link } from "react-router-dom";
import { NavLink } from "../../../lib/Navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import { useLocalStorageState, useMount } from "ahooks";
import Dialog from "../../../lib/Dialog";
import Image from "../../../lib/Image";
import { splitStr } from "../../../utils/commonFunc";

// 新游首发
export default (props) => {
  const [init, setInit] = useState();
  const [loading, setLoading] = useState();

  const [gameTodayGroups, setGameTodayGroups] = useState([]);
  const [gameOtherGroups, setGameOtherGroups] = useState([]);

  const load = (parms = {}) => {
    if (loading) {
      return;
    }
    setLoading(true);
    Dialog.loading();

    general.axios
      .post("/v3/newGames")
      .finally(() => {
        setLoading(false);
        Dialog.close();
      })
      .then((response) => {
        console.log("新游首发数据----------------", response);

        setInit(true);
        let result = response.data.data;

        setGameTodayGroups(result.today_new_games);
        setGameOtherGroups(result.week_new_games);
      })
      .catch((error) => {
        Dialog.error(error.message);
      });
  };

  useEffect(() => {
    if (props.active && !init) {
      load();
    }
  }, [props.active]);

  const [banner, setBanner] = useLocalStorageState("new-banner", {
    defaultValue: [],
  });

  useMount(() => {
    general.axios
      .post("/v3/getGameBanner")
      .then((res) => {
        let { status, data } = res.data;
        if (!status.succeed) {
          console.log(status.error_desc);
          return;
        }

        setBanner(data.banner_list);
      })
      .catch((err) => console.log(err));
  });

  return (
    <div>
      {banner?.length > 0 ? (
        <>
          <div className="new-banner">
            <Swiper
              loop={true}
              autoplay={true}
              pagination={{ clickable: true }}
            >
              {banner?.map((item, index) => (
                <SwiperSlide key={index}>
                  <NavLink
                    to={
                      item.banner_type === "game"
                        ? `/game?id=${item.game_id}`
                        : item.url
                    }
                    user={item.banner_type !== "game"}
                    iframe={
                      item.banner_type === "game"
                        ? undefined
                        : { title: item.text }
                    }
                  >
                    <img src={item.img} alt="" />
                  </NavLink>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </>
      ) : null}

      {gameTodayGroups?.length > 0 && (
        <div className="new-new">
          <div className="index-data">
            <div className="data-head">
              <span className="text">今日首发</span>
            </div>

            <div className="data-body" style={{ marginTop: "14px" }}>
              {gameTodayGroups.map((game) => (
                <Link to={"/game?id=" + game.game_id} key={game.game_id}>
                  <div className="game-list-global-type">
                    <div className="game-list-global-type-left">
                      <div className="icon">
                        <Image src={game.game_image?.thumb} />
                      </div>

                      <div className="data">
                        <div className="name">
                          <div className="name-main" style={{ flex: "none" }}>
                            {game.game_name_main || game.game_name}
                          </div>

                          <span className="start-time">
                            {game.start_time}首发
                          </span>
                        </div>

                        <div className="desc">
                          {splitStr(game.game_classify_type)}

                          {game.game_name_branch && (
                            <>
                              <div className="circle"></div>
                              {game.game_name_branch}
                            </>
                          )}
                        </div>

                        <div className="info">
                          {game.game_desc && (
                            <>
                              {game?.is_trial_game == 2 ? (
                                <>
                                  <div className="play-tag">有奖试玩</div>
                                  {game.game_desc
                                    ?.split("+")
                                    .slice(0, 1)
                                    .map((item, index) => (
                                      <div key={index} className="tag">
                                        {item}
                                      </div>
                                    ))}
                                </>
                              ) : (
                                game.game_desc
                                  ?.split("+")
                                  .slice(0, 2)
                                  .map((item, index) => (
                                    <div key={index} className="tag">
                                      {item}
                                    </div>
                                  ))
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>

                    {game?.game_tags?.is_premium_game == 2 ? (
                      <div
                        className="is-premium"
                        style={{
                          marginRight: 0,
                          backgroundImage:
                            "url('/resources/common/boutique.png')",
                        }}
                      >
                        {game.discount < 1 ? (
                          <p className="is-premium-discount">
                            {parseFloat((game.discount * 10).toFixed(2))}折
                          </p>
                        ) : null}
                        <p className="boutique">精品游戏</p>
                      </div>
                    ) : game?.game_tags?.is_free_version == 2 ? (
                      <div
                        className="is-free-version"
                        style={{ marginRight: "10px" }}
                      >
                        <span>免费版</span>
                      </div>
                    ) : (
                      <>
                        {game.discount < 1 ? (
                          <div
                            className="discount"
                            style={{ marginRight: "4px" }}
                          >
                            {parseFloat((game.discount * 10).toFixed(2))}折
                          </div>
                        ) : null}
                      </>
                    )}
                  </div>

                  {game.is_show_banner_url == 1 ? (
                    <div className="columnGames-bigImg">
                      <Image src={game.banner_url} />
                    </div>
                  ) : null}
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}

      {gameOtherGroups?.length > 0 && (
        <div className="new-new">
          <div className="index-data">
            <div className="data-head">
              <span className="text">近期上线</span>
            </div>

            <div className="data-body" style={{ marginTop: "14px" }}>
              {gameOtherGroups.map((game, index) => (
                <Link to={"/game?id=" + game.game_id} key={game.game_id}>
                  <div className="game-list-global-type">
                    <div className="game-list-global-type-left">
                      <div className="icon">
                        <Image src={game.game_image?.thumb} />
                      </div>

                      <div className="data">
                        <div className="name">
                          <div className="name-main">
                            {game.game_name_main || game.game_name}
                          </div>

                          {game?.game_tags?.is_special_server_game == 2 && (
                            <div className="dedicated-server">专服</div>
                          )}
                        </div>

                        <div className="desc">
                          {splitStr(game.game_classify_type)}
                          {game.game_name_branch && (
                            <>
                              <div className="circle"></div>
                              {game.game_name_branch}
                            </>
                          )}
                        </div>

                        <div className="info">
                          {game.game_desc && (
                            <>
                              {game?.is_trial_game == 2 ? (
                                <>
                                  <div className="play-tag">有奖试玩</div>
                                  {game.game_desc
                                    ?.split("+")
                                    .slice(0, 1)
                                    .map((item, index) => (
                                      <div key={index} className="tag">
                                        {item}
                                      </div>
                                    ))}
                                </>
                              ) : (
                                game.game_desc
                                  ?.split("+")
                                  .slice(0, 2)
                                  .map((item, index) => (
                                    <div key={index} className="tag">
                                      {item}
                                    </div>
                                  ))
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>

                    {game?.game_tags?.is_premium_game == 2 ? (
                      <div
                        className="is-premium"
                        style={{
                          marginRight: 0,
                          backgroundImage:
                            "url('/resources/common/boutique.png')",
                        }}
                      >
                        {game.discount < 1 ? (
                          <p className="is-premium-discount">
                            {parseFloat((game.discount * 10).toFixed(2))}折
                          </p>
                        ) : null}
                        <p className="boutique">精品游戏</p>
                      </div>
                    ) : game?.game_tags?.is_free_version == 2 ? (
                      <div
                        className="is-free-version"
                        style={{ marginRight: "10px" }}
                      >
                        <span>免费版</span>
                      </div>
                    ) : (
                      <>
                        {game.discount < 1 ? (
                          <div
                            className="discount"
                            style={{ marginRight: "4px" }}
                          >
                            {parseFloat((game.discount * 10).toFixed(2))}折
                          </div>
                        ) : null}
                      </>
                    )}
                  </div>

                  {game.is_show_banner_url == 1 ? (
                    <div className="columnGames-bigImg">
                      <Image src={game.banner_url} />
                    </div>
                  ) : null}
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}

      <div className="view-end">更多游戏，请搜索查找</div>
    </div>
  );
};
